<template>
  <div>
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="details"
      dateField="Date"
      numberField="ID"
    />

    <kst-output field="WarehouseID" :data="details" :catalog="Catalog"/>
    <kst-output field="CashierID" :data="details" :catalog="Catalog"/>
    <kst-output field="Total" :data="details" :catalog="Catalog"/>
    <kst-output field="CashReceived" :data="details" :catalog="Catalog"/>
    <kst-output field="Comment" :data="details" :catalog="Catalog"/>
    <kst-created :data="details"/>
  </div>
</template>

<script>
import Catalog from "../SlrcCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>